// extracted by mini-css-extract-plugin
export default {"floating-action-btn":"styles_floating-action-btn__sku8v"};